import React, { Component } from "react"
import PropTypes from "prop-types"
import Carousel from "nuka-carousel"
import { Link } from "react-router-dom"
import { ErrorIcon } from "components"
import { H2, Content, Space, AlertIcon } from "AtomicComponents"
import { ColumnGroup, Column } from "containers"
import {
  Radium,
  withRadium,
  DetectCompact,
  gtmEvent as withGtmEvent
} from "higher-order-components"
import VehicleServiceCarouselItem from "./carousel-item"
import COLOR_PALETTE from "constants/color-palette"

const RadiumCarousel = Radium(Carousel)

class VehicleServiceCarousel extends Component {
  constructor(props) {
    super(props)
    const { serviceTiles, nextServiceFactoryCode } = props

    this.state = {
      currentSlideIndex: nextServiceFactoryCode ? serviceTiles.findIndex(service => service.factoryCode === nextServiceFactoryCode) : 0
    }
  }

  render() {
    const {
      compact,
      heading,
      blurb,
      serviceTiles,
      requestUnscheduledServicePageUrl,
      gtmOnCarouselButtonClick,
      recallsPageUrl,
      gtmEvent
    } = this.props
    const { currentSlideIndex } = this.state

    const hyperlinkText = "Request an interim service >"

    return (
      <ColumnGroup verticalPadding horizontalPadding={false} fullWidth>
        <Column textAlignMobile="center" textAlign="center">
          {heading && (
            <H2 withDetails>{heading}</H2>
          )}
          <Space />
          {blurb && <Content xmlString={blurb} textAlign="center" />}
          <div style={{ padding: "3em 0" }}>
            <RadiumCarousel
              cellAlign="center"
              cellSpacing={20}
              easing="easeCubicInOut"
              slideIndex={currentSlideIndex}
              afterSlide={slideIndex => this.setState({ currentSlideIndex: slideIndex })}
              slideWidth="280px"
              slidesToShow={1}
              renderCenterLeftControls={({ previousSlide, currentSlide }) => (
                <div
                  key="left"
                  style={{
                    padding: compact ? "0.75em" : "1em",
                    marginLeft: compact ? "1em" : "2.25em",
                    cursor: currentSlide === 0 ? "default" : "pointer",
                    borderRadius: "100%",
                    opacity: currentSlide === 0 ? "0.3" : "1",
                    transition: "background 0.25s ease-in-out",
                    ":hover": { background: currentSlide === 0 ? "transparent" : COLOR_PALETTE.WHITE }
                  }}>
                  <svg
                    viewBox="0 0 27 52"
                    width={compact ? "14px" : "18px"}
                    height={compact ? "26px" : "34px"}
                    onClick={previousSlide}
                    style={{
                      transform: "rotate(180deg)",
                      transformOrigin: "center center",
                      padding: compact ? "0 5px 0 9px" : "0 7px 0 11px"
                    }}>
                    <path
                      style={{ fill: COLOR_PALETTE.BLACK }}
                      d="M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z" />
                  </svg>
                </div>
              )}
              renderCenterRightControls={({ nextSlide, currentSlide, slideCount }) => (
                <div
                  key="right"
                  style={{
                    padding: compact ? "0.75em" : "1em",
                    marginRight: compact ? "1em" : "2.25em",
                    cursor: currentSlide === slideCount - 1 ? "default" : "pointer",
                    borderRadius: "100%",
                    opacity: currentSlide === slideCount - 1 ? "0.3" : "1",
                    transition: "background 0.25s ease-in-out",
                    ":hover": {
                      background: currentSlide === slideCount - 1 ? "transparent" : COLOR_PALETTE.WHITE
                    }
                  }}>
                  <svg
                    viewBox="0 0 27 52"
                    width={compact ? "14px" : "18px"}
                    height={compact ? "26px" : "34px"}
                    onClick={nextSlide}
                    style={{ cursor: "pointer", padding: compact ? "0 5px 0 9px" : "0 7px 0 11px" }}>
                    <path
                      style={{ fill: COLOR_PALETTE.BLACK }}
                      d="M1.43,52L0,50.57,24.56,26,0,1.43,1.43,0,26.7,25.28a1,1,0,0,1,0,1.43Z" />
                  </svg>
                </div>
              )}
              renderBottomCenterControls={() => {}}>
              {serviceTiles &&
                serviceTiles.map((item, index) => {
                  return (
                    <VehicleServiceCarouselItem
                      key={index}
                      item={item}
                      index={index}
                      currentIndex={currentSlideIndex}
                      {...this.props} />
                  )
                })}
            </RadiumCarousel>
          </div>
          <Link
            gtmevents={[
              { func: gtmEvent, args: [gtmOnCarouselButtonClick({ buttonText: hyperlinkText })] }
            ]}
            text={hyperlinkText}
            to={requestUnscheduledServicePageUrl}
            style={{ color: COLOR_PALETTE.BLACK }}>
            {hyperlinkText}
          </Link>
          {recallsPageUrl &&
            <div
              style={{
                margin: "3em auto 0",
                maxWidth: "calc(1200px + 10vw)"
              }}>
              <p
                style={{
                  fontWeight: "200",
                  padding: "1.5em 0",
                  borderTop: "1px solid " + COLOR_PALETTE.GRAY,
                  borderBottom: "1px solid " + COLOR_PALETTE.GRAY,
                  lineHeight: compact ? "30px" : "38px",
                  margin: "0 5vw"
                }}>
                <span
                  style={{
                    fontSize: "18px",
                    letterSpacing: "0.2em",
                    fontWeight: "600",
                    display: compact ? "block" : "inline-block",
                    paddingRight: !compact && "1em",
                    marginRight: !compact && "1em",
                    borderRight: !compact && "1px solid " + COLOR_PALETTE.GRAY }}>
                  <AlertIcon
                    style={{
                      width: "1.25em",
                      height: "1.25em",
                      marginRight: "0.5em",
                      fill: COLOR_PALETTE.RED,
                      display: "inline-block",
                      verticalAlign: "sub" }} /> MAZDA RECALLS
                  </span>For information about recalls for your vehicle.
                  <Link to={recallsPageUrl} style={{ color: COLOR_PALETTE.BLACK, fontWeight: "600", marginLeft: "0.5em", whiteSpace: "nowrap" }}>View Recalls ></Link>
              </p>
            </div>
          }
        </Column>
      </ColumnGroup>
    )
  }
}

VehicleServiceCarousel.propTypes = {
  compact: PropTypes.bool,
  heading: PropTypes.string,
  blurb: PropTypes.string,
  serviceTiles: PropTypes.array,
  requestUnscheduledServicePageUrl: PropTypes.string,
  requestServicePageUrl: PropTypes.string,
  registerRoutes: PropTypes.func,
  services: PropTypes.object,
  gtmOnCarouselButtonClick: PropTypes.func,
  recallsPageUrl: PropTypes.string,
  gtmEvent: PropTypes.func,
  vin: PropTypes.string
}

export default withRadium(DetectCompact(), withGtmEvent())(VehicleServiceCarousel)



// WEBPACK FOOTER //
// ./src/components/mymazda/service/carousel.jsx